import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth, useUserToken } from "@/context/auth-context";
import { User } from "@/types/user";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

const useCurrentUser = () => {
  const userToken = useUserToken();
  const auth = useAuth();

  return useQuery(
    [ENDPOINTS.me],
    (): Promise<User> =>
      fetch(ENDPOINTS.me, {
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    {
      staleTime: 1000 * 30, // 30 seconds - prevents unnecessary background refetches
      onSuccess: (response: User) => {
        if (JSON.stringify(auth?.user) !== JSON.stringify(response)) {
          auth?.updateUserState(response);
        }
      },
    },
  );
};

export { useCurrentUser };
